import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';

import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ProjectsAccordionComponent } from '../components/projects-accordion/projects-accordion.component';
import { ProjectsService } from 'src/app/services/api/projects.service';
import { AlertNotificationService } from 'src/app/services/alert-notification.service';
import { MainLayoutService } from 'src/app/services/main-layout.service';
import { RouteService } from 'src/app/services/route.service';

@Component({
  selector: 'app-projects-edit-page',
  imports: [RouterModule, ProjectsAccordionComponent],
  templateUrl: './projects-edit-page.component.html',
  styleUrl: './projects-edit-page.component.scss'
})
export class ProjectsEditPageComponent implements OnInit, OnDestroy {
  @ViewChild(ProjectsAccordionComponent) projectsAccordion?: ProjectsAccordionComponent;
  
  projectId?: string;
  project: any = {};
  formData: any = {
    summary: {},
    team: {},
    workingList: {},
    checkList: {},
    testList: {},
    issues: {},
    summaryReport: {},
    finance: {},
    certificate: {},
    contractsDocs: {},
    rtp: {}
  };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private projectsService: ProjectsService,
    private alertNotificationService: AlertNotificationService,
    private mainLayoutService: MainLayoutService,
    private routeService: RouteService
  ) { }

  ngOnInit(): void {
    const projectId = this.route.snapshot.paramMap.get('projectId');
    this.projectId = projectId ? projectId : undefined;
    if (projectId) {
      this.loadProjectData(projectId);
    }     
  }


  loadProjectData(projectId: string): void {
    this.projectsService.detail(Number(projectId)).subscribe({
      next: (response) => {
        if (response.status.code === 200) {
          this.project = response.data.project;
          this.mainLayoutService.setRelatedCodeItem(this.project?.code || null);
          this.mainLayoutService.setClientCompanyName(this.project?.clientCompanyName || null);
        }
      },
      error: (error) => {
        console.error('Error loading project:', error);
        this.alertNotificationService.error('Error loading project data');
      }
    });
  }

  onFormDataUpdated(event: any): void {
    if (event && event.type) {
      this.formData[event.type] = event.data;
    }
  }

  submitSummaryForm(): void {
    if (this.projectsAccordion && this.projectsAccordion.projectsSummaryComponent) {
      this.projectsAccordion.projectsSummaryComponent.submitForm();
    } else {
      this.alertNotificationService.error('Summary component not available');
    }
  }

  submitActiveForm(): void {
    if (this.projectsAccordion) {
      this.projectsAccordion.submitActiveChildForm();
    } else {
      this.submitSummaryForm();
    }
  }

  goToViewProject(): void {
    if (!this.projectId) {
      return;
    }
    this.routeService.projectsDetail(Number(this.projectId));
  }
  
  ngOnDestroy(): void {
    this.mainLayoutService.setClientCompanyName(null);
  }
}
